import {combineLatest, interval, Observable, Subject} from 'rxjs';
import {ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {map, takeUntil} from 'rxjs/operators';
import {DataService} from '../services/data.service';
import {Budget} from '../interfaces';
import {MatCard, MatCardContent, MatCardSubtitle, MatCardTitle} from '@angular/material/card';
import {MatIcon} from '@angular/material/icon';
import {NgClass} from '@angular/common';
import {
    MatCell,
    MatCellDef,
    MatColumnDef,
    MatHeaderCell, MatHeaderCellDef, MatHeaderRow,
    MatHeaderRowDef,
    MatRow,
    MatRowDef, MatTable
} from '@angular/material/table';
import {MatButton} from '@angular/material/button';



@Component({
    selector: 'app-workers-summary-list',
    templateUrl: './workers-summary-list.component.html',
    imports: [
        MatCardContent,
        MatCardSubtitle,
        MatCard,
        MatCardTitle,
        MatIcon,
        NgClass,
        MatHeaderCell,
        MatCellDef,
        MatCellDef,
        MatCellDef,
        MatHeaderRowDef,
        MatRowDef,
        MatCell,
        MatColumnDef,
        MatRow,
        MatTable,
        MatHeaderRow,
        MatButton,
        MatHeaderCellDef
    ],
    styleUrls: ['./workers-summary-list.component.scss']
})
export class WorkersSummaryListComponent implements OnInit, OnDestroy {

    @Input()
    set timeInterval(value: number) {
        if (value) {
            this._timeInterval = value;
        }
    }

    constructor(private dataService: DataService, private _changeDetectionRef: ChangeDetectorRef) {
    }

    public projects$: Observable<Partial<Budget>[]>;

    public resumes: any[] = [];

    public displayedResumes: any[] = [];

    public displayedColumns = ['ppm', 'comm', 'ces', 'form', 'pieg', 'laser', 'asm', 'mon', 'trasp', 'mic', 'pul', 'contr'];

    private unsubscribeInterval$ = new Subject();
    private unsubscribe$ = new Subject();

    @Input()
    public canChange = false;

    private _timeInterval = 5000;

    public fullScreenActive = false;

    ngOnInit() {

        this.projects$ = this.dataService.getBudgetsForWorkersList();
        this.projects$.pipe(takeUntil(this.unsubscribe$)).subscribe((projects: any[]) => {

            const obs = [];

            for (const project of projects) {

                obs.push(this.dataService.getSubBudgetResume(project.id).pipe(
                    map((summary: any) => {
                        console.log('returned summary: ', project.id, project.description, summary);

                        const budgetReport = {};
                        const finalReport = {};
                        for (const act of summary.activities) {
                            const key = act.name ? act.name : act.activity;
                            budgetReport[key] = {value: act.hours, cssClass: 'budget-hour'};
                            finalReport[key] = {
                                value: act.finalHours,
                                cssClass: act.finalHours > act.hours ? 'red' : 'green'
                            };
                        }
                        summary.budgetId = project.id;
                        summary.budgetReport = budgetReport;
                        summary.finalReport = finalReport;
                        summary.report = [summary.budgetReport, summary.finalReport];
                        summary.projectNr = project.project?.projectNr;
                        summary.budgetNr = project.budgetNr;
                        summary.description = project.description ? project.description : project.company ? project.company.name : '';
                        summary.client = project.company ? project.company.companyName : '';

                        return summary;
                    })));
            }

            combineLatest(obs).pipe(takeUntil(this.unsubscribe$)).subscribe((resumes) => {
                console.log('got resumes:', resumes);
                this.resumes = resumes;
                this.displayedResumes = this.resumes.slice();
            }, err => {
                console.error(err);
            });

            return projects;
        });

        document.addEventListener('fullscreenchange', this.fullScreenHandler, false);
        document.addEventListener('mozfullscreenchange', this.fullScreenHandler, false);
        document.addEventListener('MSFullscreenChange', this.fullScreenHandler, false);
        document.addEventListener('webkitfullscreenchange', this.fullScreenHandler, false);
    }

    public fullScreenHandler = () => {
        console.log('fullScreenHandler!! ', this.fullScreenActive);
        this.fullScreenActive = !this.fullScreenActive;

        if (!this.fullScreenActive) {
            console.log('We are not in full screen, removing interval if exists.. ');
            this.unsubscribeInterval$.next(true);
            this.displayedResumes = this.resumes.slice();
        }
    }

    rotate() {

        if (this.displayedResumes.length > 3) {
            this.displayedResumes.push(this.displayedResumes.shift());
            this.displayedResumes.push(this.displayedResumes.shift());
            this._changeDetectionRef.detectChanges();
        }

    }

    goFullscreen() {

        interval(this._timeInterval).pipe(takeUntil(this.unsubscribeInterval$)).subscribe(() => {
            this.rotate();
        });

        const element = document.getElementById('container');
        if (element && document.fullscreenEnabled) {
            element.requestFullscreen();
        }
    }

    removeItem(id: string) {
        console.log('removing budget:', id);
        this.dataService.deselectForWorkersList(id).then(res => {
            this.resumes = [];
        });
    }

    public ngOnDestroy() {
        this.unsubscribe$.next(null);
        this.unsubscribe$.complete();

        this.unsubscribeInterval$.next(null);
        this.unsubscribeInterval$.complete();
    }
}